import datapoints from './datapoints';
import { deleteItems } from './deleteItems';
import blockLastSendersHelper from './helpers/blockLastSendersHelper';
import { getSweepableMailboxesFromItemIds } from './helpers/getSweepableMailboxes';
import { isControlFeatureEnabled } from 'owa-controls-feature-flags';
import { trace } from 'owa-trace';
import { action } from 'satcheljs/lib/legacy';
/**
 * Block the sender smtp addresses from the given item ids
 * @param itemIdToBlock the item id
 */
export default function blockLastSenderFromReadingPane(itemId, instrumentationContexts) {
    if (!itemId) {
        trace.error('blockLastSendersFromReadingPane should not be called on invalid items.');
        return;
    }
    // De-duped senders
    var mailboxes = getSweepableMailboxesFromItemIds([itemId]);
    blockLastSendersHelper(mailboxes, function () {
        deleteItemUponBlock(itemId, instrumentationContexts);
    });
}
var deleteItemUponBlock = action('deleteItemUponBlock', datapoints.blockSenderFromReadingPaneDatapoint)(function deleteItemUponBlock(itemIdToBlock, instrumentationContexts) {
    var disposalType = isControlFeatureEnabled('doc-consumerUrl')
        ? 'HardDelete'
        : 'MoveToDeletedItems';
    return deleteItems([itemIdToBlock], disposalType, 'NonUserAction' /* actionSource */, instrumentationContexts);
});
//# sourceMappingURL=blockLastSenderFromReadingPane.js.map